import api from './api';

const BASE = '/loyalty/earning-rules';

export const earningRulesAPI = {
  getEarningRules: async (params) => {
    const response = await api.get(`${BASE}/`, { params });
    return response.data;
  },

  getEarningRule: async (id) => {
    const response = await api.get(`${BASE}/${id}/`);
    return response.data;
  },

  createEarningRule: async (data) => {
    const response = await api.post(`${BASE}/`, data);
    return response.data;
  },

  updateEarningRule: async (id, data) => {
    const response = await api.patch(`${BASE}/${id}/`, data);
    return response.data;
  },

  deleteEarningRule: async (id) => {
    const response = await api.delete(`${BASE}/${id}/`);
    return response.data;
  },

  toggleActive: async (id) => {
    const response = await api.post(`${BASE}/${id}/toggle_active/`);
    return response.data;
  },

  getActiveRules: async () => {
    const response = await api.get(`${BASE}/active/`);
    return response.data;
  },

  duplicateRule: async (id) => {
    const response = await api.post(`${BASE}/${id}/duplicate/`);
    return response.data;
  },

  getRuleTypes: async () => {
    const response = await api.get(`${BASE}/rule_types/`);
    return response.data;
  },

  getStatistics: async () => {
    const response = await api.get(`${BASE}/statistics/`);
    return response.data;
  },

  testCalculation: async (data) => {
    const response = await api.post(`${BASE}/test_calculation/`, data);
    return response.data;
  },
};
